import React, { useEffect, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { AddManualAttendanceListData, AddManualAttendanceTableData } from "./data/AddManualAttendanceList.Data";
import { useRef } from "react";
import Buttons from "../../components/ui/button/Buttons";
import { useLazyGetAllDropDownsQuery } from "../../app/services/common/commonApi";
import { setAllDropDownFields } from "./utils/setFieldParameter";
import { useParams } from "react-router-dom";
import { useApproveManualAttendanceMutation, useDeleteCpdEventAttendanceByIdMutation, useGetManualtAttendanceListByCpdEventMutation, useLazyGetAllDropdownEventByCourseProviderIdQuery, useLazyGetAttendanceByCpdEventIdQuery } from "../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import AddManualAttendance from "./component/AddManualAttendance";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import SwalAlert from "../../services/swalService/SwalService";
import { getAuthProps } from "../../lib/authenticationLibrary";

const AddManualAttendanceList = (props) => {
  const { id } = useParams();
  const AddManualAttendanceListRef = useRef();
  const AddManualAttendanceTableRef = useRef();
  const [formData, setFromData] = useState(AddManualAttendanceListData)
  const [courseProviderId, setCourseProviderId] = useState()
  const [eventId, setEventId] = useState()
  const [isModelOpen, setIsModalOpen] = useState(false);
  const { confirm, success, error } = SwalAlert();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    CourseProviderId: null,
    CpdEventId: null,
  });
  const [dataSource, setDataSource] = useState([]);
  const [finalCpdPoint, setFinalCpdPoint] = useState(null);

  const [getAllDropDowns, { isSuccess: isGetAllDropDownFetched, isLoading: isGetDropDownFetching, data: allDropDownResponse },] = useLazyGetAllDropDownsQuery();
  const [getAllDropdownEvent, { isSuccess: isGetAllDropdownEventFetched, isLoading: isGetAllDropdownEventFetching, data: getAllDropdownEventData },] = useLazyGetAllDropdownEventByCourseProviderIdQuery();
  const [getAttendanceByCpdEventId, { isSuccess: isSuccess, isFetching: isCpdFetching, data: getCpdEventResponse },] = useLazyGetAttendanceByCpdEventIdQuery();
  const [approveManualAttendance, { isSuccess: isSuccessApproveManualAttendance, isLoading: isLoadingApproveManualAttendance, data: approveManualAttendanceData, },] = useApproveManualAttendanceMutation();

  useEffect(() => {
    getAllDropDowns();
  }, [])

  useEffect(() => {
    if (!isLoadingApproveManualAttendance && isSuccessApproveManualAttendance && approveManualAttendanceData) {
      success("Manual Attendance Approved Successfully")
      setDataSource([]);
    }
  }, [isLoadingApproveManualAttendance, isSuccessApproveManualAttendance, approveManualAttendanceData]);

  useEffect(() => {
    if (isGetAllDropDownFetched && allDropDownResponse) {
      setAllDropDownFields(allDropDownResponse);
    }
  }, [isGetAllDropDownFetched, allDropDownResponse]);
  useEffect(() => {
    if (isSuccess && getCpdEventResponse) {
      setFinalCpdPoint(getCpdEventResponse.finalCpdPoint || null);
    }
  }, [isSuccess, isCpdFetching, getCpdEventResponse]);

  const handlePushOptionObject = () => {
    let authData = getAuthProps();

    const request = {
      ApproveAttandence: dataSource.map((item) => ({
        CpdEventId: item.CpdEventId,
        GMPNumber: item.gmpNumber,
        GMPName: item.gmpName,
        UpdatedBy : 115,
        UpdatedAppId : authData?.adminUserId
      })),
    };
    approveManualAttendance(request);
  };

  useEffect(() => {
    if (isGetAllDropdownEventFetched && getAllDropdownEventData) {
      let eventDropdowns = setAllDropDownFields(getAllDropdownEventData, 'event');
      setFromData(eventDropdowns);
    }
  }, [isGetAllDropdownEventFetched, getAllDropdownEventData]);


  const handleFormFieldChange = (dataField, value) => {
    if (dataField === "courseId") {
      setCourseProviderId(value?.value);
      getAllDropdownEvent(value?.value)
      setDataSource([]);
    }
    else if (dataField === "eventId") {
      setEventId(value?.value)
      getAttendanceByCpdEventId(value?.value);
      setDataSource([]);
    }
  };

  const openCloseModal = () => {
    setIsModalOpen(!isModelOpen);
  };

  const handleOpenModel = () => {
    setIsModalOpen(!isModelOpen)
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize, CourseProviderId: courseProviderId, CpdEventId: eventId };
    setPaginationRequest(updatedPaginationRequest);
  };

  const handleDelete = (data) => {
    confirm('Delete?', 'Are you sure you want to delete this record?', 'Delete', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          setDataSource((prevData) => {
            const updatedData = prevData.filter((item) => item.index !== data.index);
            return updatedData;
          });
          success("Record deleted successfully.");
        }
      });
  };


  const actionHandler = {
    DELETE: handleDelete,
  };

  const getdata = (dataList) => {
    const normalizedDataList = Array.isArray(dataList) ? dataList : [dataList];

    const formattedData = normalizedDataList.map((item, index) => ({
      CpdEventId: item?.CpdEventId,
      index: Date.now() + index,
      gmpName: item?.GmpName,
      gmpNumber: item?.GmpNumber,
    }));

    setDataSource((prevData) => {
      const duplicate = formattedData.find((newItem) =>
        prevData.some((existingItem) => existingItem.gmpNumber === newItem.gmpNumber)
      );
      if (duplicate) {
        error(`GMP Number '${duplicate.gmpNumber}' already exists.`);
        return prevData;
      }
      return [...prevData, ...formattedData];
    });
  };

  return (
    <div>
      <div className="form-section">
        <div className="row">
          <div className="row col-12">
            {!isGetDropDownFetching &&
              < FormCreator
                ref={AddManualAttendanceListRef}
                {...formData}
                onFormFieldValueChange={handleFormFieldChange}
              />
            }
          </div>
          <div className="d-flex my-2">
            <span>Approved CPD Points :&nbsp;{finalCpdPoint}</span>
          </div>
        </div>
        <div className="reset-password-button">
          {isModelOpen && (
            <CenterModel
              modelTitle={"Manual Attendance"}
              show={"test"}
              handleClose={openCloseModal}
              onUpload={openCloseModal}
            >
              <AddManualAttendance eventId={eventId} courseProviderId={courseProviderId} paginationRequest={paginationRequest}
                getdata={getdata} />
            </CenterModel>
          )}
          <div className="my-4">
            <Buttons
              buttonText="+ Add GMP"
              buttonTypeClassName="outline-btn"
              onClick={() => handleOpenModel()}
            />
          </div>
        </div>
        <FinalMolGrid
          ref={AddManualAttendanceTableRef}
          configuration={AddManualAttendanceTableData}
          dataSource={dataSource}
          allowPagination={true}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
        <div className="mt-5">
          <Buttons
            buttonText="Award Points"
            buttonTypeClassName="success-btn  ml-auto"
            onClick={handlePushOptionObject}
          />
        </div>
      </div>
    </div>
  );
};

export default AddManualAttendanceList;
